var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUsc = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 609.000000 609.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,609.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M913 3983 l3 -2108 22 -110 c63 -320 156 -552 327 -810 476 -723 1350 -1083 2204 -910 308 63 614 204 876 404 84 64 275 252 348 341 264 327 428 731 466 1150 7 72 11 527 11 1218 l0 1102 -305 0 -305 0 0 -1057 c0 -1052 -5 -1218 -36 -1370 -121 -598 -585 -1060 -1194 -1190 -122 -26 -459 -26 -580 0 -198 43 -378 115 -527 213 -356 231 -581 562 -676 992 -21 97 -21 106 -24 1860 l-4 1762 911 0 910 0 0 310 0 310 -1215 0 -1215 0 3 -2107z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3950 5780 l0 -310 305 0 305 0 0 -305 0 -305 305 0 305 0 0 615 0 615 -610 0 -610 0 0 -310z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUsc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/USC.f774ff06.svg";
export { ForwardRef as ReactComponent };